import { render, staticRenderFns } from "./Members.vue?vue&type=template&id=22c89e56"
import script from "./Members.vue?vue&type=script&lang=ts"
export * from "./Members.vue?vue&type=script&lang=ts"
import style0 from "./Members.vue?vue&type=style&index=0&id=22c89e56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_op2felhwcemqlmdmuodyzlbaea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports